import { CatalogsInfoResponse } from '@e-origin/contracts';

import { apiClient } from '@utils';

export const useAdminCatalogsInfo = () => {
  const result = apiClient.catalogs.getCatalogsInfo.useQuery(
    ['admin-catalogs-info'],
    {},
    {
      queryKey: ['admin-catalogs-info'],
      placeholderData: { body: { testCollectionsAvailability: null, syncRequired: false, downloadUrls: {} } } as any,
    },
  );
  return { ...result, data: result.data?.body as CatalogsInfoResponse };
};
